<template>
  <div class="passwordStrategy" v-loading.fullscreen.lock="loading">
    <h1>密码策略</h1>
    <div class="content">
      <div class="item">
        <div class="explain">需要数字:</div>
        <el-switch
          v-model="test.requireDigit"
          active-color="#13ce66"
          inactive-color="#ff4949"
        />
      </div>
      <div class="item">
        <div class="explain">要求小写:</div>
        <el-switch
          v-model="test.requireLowercase"
          active-color="#13ce66"
          inactive-color="#ff4949"
        />
      </div>
      <div class="item">
        <div class="explain">要求大写:</div>
        <el-switch
          v-model="test.requireUppercase"
          active-color="#13ce66"
          inactive-color="#ff4949"
        />
      </div>
      <div class="item">
        <div class="explain">需要特殊字符:</div>
        <el-switch
          v-model="test.requireNonAlphanumeric"
          active-color="#13ce66"
          inactive-color="#ff4949"
        />
      </div>
      <div class="item">
        <div class="explain">要求长度:</div>
        <el-input
          style="width: 100px"
          v-model="test.requireLength"
          type="number"
          @keydown="onKeydownEnter"
          >></el-input
        >
      </div>
      <div class="item">
        <div class="explain">要求不连续性:</div>
        <el-input
          style="width: 100px"
          v-model="test.requireDiscontinuity"
          type="number"
          @keydown="onKeydownEnter"
        ></el-input>
      </div>
    </div>
    <el-button style="float: right" @click="save">确定修改</el-button>
  </div>
</template>

<script>
import { postPasswordStrategy,getPasswordStrategy } from "@/api/zone.js";
export default {
  data() {
    return {
      loading: true,
      test: {
        requireDigit: false, //需要数字
        requireLowercase: false, //要求小写
        requireUppercase: false, //要求大写
        requireNonAlphanumeric: false, //需要特殊字符
        requireLength: "8", //要求长度
        requireDiscontinuity: "4", //要求不连续性
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    save() {
      if (this.test.requireLength) {
        this.test.requireLength = Number(this.test.requireLength);
      } else {
        this.test.requireLength = null;
      }
      if (this.test.requireDiscontinuity) {
        this.test.requireDiscontinuity = Number(this.test.requireDiscontinuity);
      } else {
        this.test.requireDiscontinuity = null;
      }
      postPasswordStrategy(this.test)
        .then((res) => {
          if (res.status == 0) {
            this.$message.success("已保存");
            this.init();
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    init() {
      getPasswordStrategy()
        .then((res) => {
          if (res.status == 0) {
            this.test = res;
            delete this.test.status;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onKeydownEnter(e) {
      let key = e.key;
      // 不允许输入'e'和'.'
      if (key === "e" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
}

.passwordStrategy {
  padding: 50px;
  width: 100%;
}

.passwordStrategy .content {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.passwordStrategy .content .item {
  height: 50px;
  width: 33%;
  display: flex;
  align-items: center;
  margin: 15px 0;
}

.passwordStrategy .content .item .explain {
  width: 100px;
  margin-right: 20px;
}
</style>